// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/bi/bi.actions.go

export const LIST_DASHBOARDS = "mondoo.bi.BIDashboardService.ListDashboards";
